import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import SnackbarUtils from 'utils/SnackbarUtils';
import CustomIconButton from '../../../../../../components/CustomIconButton/CustomIconButton';
import DoneIcon from '../../../../../../components/Icons/DoneIcon';
import RefreshIcon from '../../../../../../components/Icons/RefreshIcon';
import { contratoEntePrivadoAlteraStatus } from '../../../../../../store/modules/ContratosEntePrivadoActions';
import { getElementID } from '../../../../../../utils/HTMLUtils';
import arquivosStyles from '../Arquivos.scss';

class AtivarButton extends Component {
  isShown = () => {
    return (
      this.props.auth.userPermissions.contratos.entePrivado.changeStatus &&
      !this.props.arquivo.ativo
    );
  };

  changeStatus = () => {
    const arquivo = this.props.arquivo;
    this.props.contratoEntePrivadoAlteraStatus(
      arquivo.id,
      arquivo.versaoContrato,
      () => {
        SnackbarUtils.enqueueSnackbar({
          message: this.props.languageValues.successAtivarDocumento,
          options: {
            variant: 'success',
          },
        });
        this.props.refreshStep();
      },
      (error) => {
        SnackbarUtils.enqueueSnackbar({
          message:
            error.response.statusText ||
            this.props.languageValues.errorAtivarDocumento,
          options: {
            variant: 'error',
          },
        });
      }
    );
  };

  onClick = () => {
    this.changeStatus();
  };

  isLoading = () => {
    return this.props.contratosEntePrivado.loadingAlteraStatus;
  };

  isDisabled = () => {
    const arquivo = this.props.arquivo;
    return (
      this.isLoading() ||
      !arquivo.isLatest ||
      arquivo.idDocAssinado ||
      this.props.contratosEntePrivado.loadingAlteraArquivo ||
      !this.isShown()
    );
  };

  render() {
    const arquivo = this.props.arquivo;
    return arquivo && this.isShown() ? (
      <CustomIconButton
        id={getElementID(this.props.id, 'ativar-' + arquivo.id)}
        className={arquivosStyles.rootClassName + '-action-button'}
        onClick={() => this.onClick()}
        tooltipProps={{
          className:
            arquivosStyles.rootClassName + '-action-button-tooltip-caller',
        }}
        size='small'
        tooltip={this.props.languageValues.cadastroContratoArquivosAtivar}
        icon={this.isLoading() ? <RefreshIcon /> : <DoneIcon />}
        theme='pufvYellow'
        disabled={this.isDisabled()}
      />
    ) : null;
  }
}

AtivarButton.propTypes = {
  id: PropTypes.string.isRequired,
  refreshStep: PropTypes.func.isRequired,
  arquivo: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
  contratos: state.contratos,
  contratosEntePrivado: state.contratosEntePrivado,
  auth: state.auth,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      contratoEntePrivadoAlteraStatus,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(AtivarButton);
